import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from '../services/operations/loginAPi';

const loginSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: false,
        user: null,
        loading: false,
        error: null,
    },
    reducers: {
        logoutUser(state) {
            // Set cookie domain based on environment
            const environment = process.env.REACT_APP_ENV || 'production';
            let domain;
            
            if (environment === 'development' || environment === 'local') {
                domain = 'localhost';
            } else {
                domain = 'katalisia.com';
            }
            
            document.cookie = `authToken=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
            state.isAuthenticated = false;
            state.user = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loading = false;
                state.isAuthenticated = true;
                state.user = action.payload;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { logoutUser } = loginSlice.actions;
export default loginSlice.reducer;
